module.exports = __webpack_public_path__ + "img/103.3.2b69a4f8.png";